import type { CalendarDate } from "@internationalized/date";
import type { BestFareByDate } from "@jetblue/dotcom-api/best-fares";
import { formatCurrency, formatPoints } from "./format-price";

const getSelectedDateFareDescription = (
  fare: BestFareByDate,
  shouldUsePoints: boolean,
  currencyCode?: string,
) => {
  if (shouldUsePoints) {
    return `${formatPoints(fare.amount)} points`;
  }

  return formatCurrency(fare.amount, currencyCode);
};

type GetSelectedDateAnnouncementInput = {
  currencyCode?: string;
  fare?: BestFareByDate;
  message?: string;
  selectedDate?: CalendarDate;
  usePoints: boolean;
};

export const getSelectedDateAnnouncement = ({
  currencyCode,
  fare,
  message,
  selectedDate,
  usePoints,
}: GetSelectedDateAnnouncementInput): string | undefined => {
  if (!selectedDate || !fare || !message) {
    return undefined;
  }

  const trimmedMessage = message.replace(/[.!?]\s*$/, "");

  return `${getSelectedDateFareDescription(fare, usePoints, currencyCode)}. ${trimmedMessage}.`;
};
